"use strict";

/**
 * Events der Kartenaktionen des FeatureInfo-Moduls.
 *
 * @enum {string}
 */
gc.gis.module.GCFeatureInfoProviderEvent = {
    /**
     * Wird ausgelöst, wenn das Identify gestartet wird.
     * @event gc.gis.module.GCFeatureInfoProvider.Event#identify:start
     */
    IDENTIFYSTARTED:    'identify:started',
    /**
     * Wird ausgelöst, wenn das Identify beendet wurde (d.h. das Ergebnis vorliegt).
     * @event gc.gis.module.GCFeatureInfoProvider.Event#identify:end
     */
    IDENTIFYEND:        'identify:end',
    /**
     * Wird ausgelöst, wenn das Identify mit einem Fehler beendet wurde.
     * @event gc.gis.module.GCFeatureInfoProvider.Event#identify:error
     */
    IDENTIFYERROR:      'identify:error',

    /**
     * Wird ausgelöst, wenn die Detailermittlung gestartet wird.
     * @event gc.gis.module.GCFeatureInfoProvider.Event#detail:start
     */
    DETAILSTART:        'detail:start',
    /**
     * Wird ausgelöst, wenn die Detailermittlung beendet wurde (d.h. das Ergebnis vorliegt).
     * @event gc.gis.module.GCFeatureInfoProvider.Event#detail:end
     */
    DETAILEND:          'detail:end',
    /**
     * Wird ausgelöst, wenn die Detailermittlung mit einem Fehler beendet wurde.
     * @event gc.gis.module.GCFeatureInfoProvider.Event#detail:error
     */
    DETAILERROR:        'detail:error'
};

/**
 * @classdesc
 * Abstrakter FeatureInfo-Provider.
 *
 * @abstract
 * @class
 * @extends gc.gis.GCObservable
 * @memberof gc.gis.module
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {gc.gis.module.GCFeatureInfo} module Referenz auf das Feature-Info-Modul
 */
gc.gis.module.GCFeatureInfoProvider = function(module)
{
    gc.gis.GCObservable.call(this);

    this.module = module;
};
gc.gis.module.GCFeatureInfoProvider.prototype = Object.create(gc.gis.GCObservable.prototype);

/**
 * Identifiziert die Features zu einer Geometry und liefert die Feature-Infos.
 *
 * @public
 * @abstract
 * @method
 * @param {gc.gis.layer.GCLayer} layer der abzufragende Layer
 * @param {gc.gis.geom.GCGeometry} geometry Abfragegeometrie
 * @param {int} opt_limit max. Anzahl der zurückzugebenden Features
 */
gc.gis.module.GCFeatureInfoProvider.prototype.identify = gc.gis.abstractMethod;


/**
 * Liefert die Detailinformationen zu einem Feature.
 *
 * @public
 * @abstract
 * @method
 * @param {gc.gis.layer.GCLayer} layer der abzufragende Layer
 * @param {gc.gis.feature.GCFeature|gc.gis.feature.GCFeature[]} features Abfrageergebnis
 */
gc.gis.module.GCFeatureInfoProvider.prototype.renderDetail = gc.gis.abstractMethod;


/**
 * Erzeugt einen Provider zur Bearbeitung von FeatureInfos anhand eines Layers.
 *
 * @public
 * @method
 * @param {gc.gis.layer.GCLayer} layer der abzufragende Layer
 * @param {gc.gis.module.GCFeatureInfo} module Referenz auf das Feature-Info-Modul
 * @return gc.gis.module.GCFeatureInfoProvider
 */
gc.gis.module.GCFeatureInfoProvider.createInfoProvider = function(layer, module)
{
    if (layer.isInternal()) {
        // FIXME: Implementierung der Kartenbibliothek beachten
        return new gc.gis.module.GCFeatureInfoProvider.OLInternalLayer(module);
    }
    else if (layer instanceof gc.gis.layer.GCRasterLayer) {
        // FIXME: Implementierung der Kartenbibliothek beachten
        return new gc.gis.module.GCFeatureInfoProvider.OLWMSLayer(
            module,
            module.getMap(),
            gc.gis.iface.mapFactory,
            gc.gis.iface.request,
            gc.gis.iface.log
        );
    }
    else if (layer instanceof gc.gis.layer.GCVectorLayer) {
        // FIXME: Implementierung der Kartenbibliothek beachten
        return new gc.gis.module.GCFeatureInfoProvider.OLWFSLayer(module);
    }
    else {
        throw new gc.gis.error.GCError('FeatureInfo wird nicht unterstützt für Layer "' + layer.getName() + '" '
            + '(kein FeatureInfo Provider verfügbar).');
    }
};